import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SelectionBox = () => {
    return (
        <div className="select-box-options position-relative">
            <div className="select-box-title d-flex justify-content-between align-items-end"><span>برند</span><span
                className="delete delete-button-value-select-input">حذف</span></div>
            <div value="default" className="select-content change-select position-relative input-select-toggle">
                <span className="default-name-input">نام برند</span>
                <div className="name-content"><span className="name-selection"></span></div>
                <IconName name="expand_more" className="icon position-absolute select-box-more-icon"/>
                <IconName name="loyalty" className="icon position-absolute select-box-icon-input"/>
            </div>
            <div className="selection-options position-absolute">
                <div className="option" data-value="value1">شیائومی</div>
                <div className="option" data-value="value2">سامسونگ</div>
                <div className="option" data-value="value3">اپل</div>
                <div className="option" data-value="value4">هواوی</div>
            </div>
        </div>
    );
};

export default SelectionBox;
